import React from 'react'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'
import PropTypes from 'prop-types'
import pick from './utilities/pick'
import mapDispatchers from './utilities/mapDispatchers'
import styles from './CompleteInstagramRedirectLogin.icss'
import getStartLocationForUser from './utilities/getStartLocationForUser'

class CompleteInstagramRedirectLogin extends React.Component {
	componentDidMount() {
		this.props.appBackButtonFunction(() => this.props.appRedirect('/login'))
		this.props.authInstagramRedirectLoginComplete()
	}

	componentDidUpdate() {
		//  See if the user actually got logged in.
		if (this.props.instagramLoginCompleteSuccess &&
			!this.props.user.isAnonymous && !this.props.user.isLoading) {
			this.props.appRedirect(getStartLocationForUser(this.props.user))
		}
	}

	render() {
		return (
			<section className={this.props.instagramLoginCompleteFail ? null : styles.surround}>
				<div className={styles.container}>
					<h2>{this.context.translate('Completing Instagram login')}</h2>
				</div>
				{this.props.instagramLoginCompleteFail && (
					<div className={styles.container}>
						<p>{this.context.translate('Instagram login failed.')}</p>
						<Button
							fullWidth
							variant="contained"
							onClick={() => this.props.appRedirect('/login')}
							classes={{ root: styles.button, label: styles.label }}
						>
							{this.context.translate('Please login again')}
						</Button>
					</div>
				)}
			</section>
		)
	}
}

CompleteInstagramRedirectLogin.propTypes = {
	user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	instagramLoginCompleteSuccess: PropTypes.bool,
	instagramLoginCompleteFail: PropTypes.bool,
	appRedirect: PropTypes.func.isRequired,
	appBackButtonFunction: PropTypes.func.isRequired,
	authInstagramRedirectLoginComplete: PropTypes.func.isRequired
}

CompleteInstagramRedirectLogin.contextTypes = {
	translate: PropTypes.func
}

CompleteInstagramRedirectLogin.defaultProps = {
	instagramLoginCompleteSuccess: false,
	instagramLoginCompleteFail: false
}

export const testing = {
	CompleteInstagramRedirectLogin
}

export default connect(
	/* istanbul ignore next line */
	state => pick(state, ['user', 'instagramLoginCompleteSuccess', 'instagramLoginCompleteFail']),
	/* istanbul ignore next line */
	dispatch => mapDispatchers(dispatch, ['appRedirect', 'appBackButtonFunction', 'authInstagramRedirectLoginComplete'])
)(CompleteInstagramRedirectLogin)



// WEBPACK FOOTER //
// ./src/CompleteInstagramRedirectLogin.jsx